export default __webpack_public_path__ + "img/close_button.a9e54716.svg";